var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-input',{staticStyle:{"width":"200px"},attrs:{"search":"","value":_vm.value || _vm.values,"placeholder":_vm.placeholder?_vm.placeholder:_vm.$t('Common-search-item0')},on:{"on-change":_vm.onInputChange,"on-search":_vm.search}})}
var staticRenderFns = []

export { render, staticRenderFns }